// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { getSafeDueDate, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';

export function TicketDue(): Node {
  const expirationDateTime = getSafeDueDate(usePendingIncomingPayment());

  return (
    <Root>
      <Term>Pagar antes de</Term>
      <Separator direction="vertical" size={2} />
      <Definition>{formatDueDate(expirationDateTime)}</Definition>
    </Root>
  );
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;

function formatDueDate(stringDate: string): string {
  const date = new Date(stringDate);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${pad(day)}/${pad(month)}/${pad(year)} ${pad(hours)}:${pad(minutes)}`;
}

function pad(n: number): string {
  return String(n).padStart(2, '0');
}
